<script setup lang="ts">
const { currentConstructionSite } = useConstructionSite();
const { coords } = useGPS();

const hasGeolocation = ref<boolean>();
watchEffect(() => {
  if (!coords.value) {
    return (hasGeolocation.value = false);
  }

  return (hasGeolocation.value = true);
});
</script>

<template>
  <div
    class="fixed bg-background bottom-0 z-50 left-0 right-0 border-t border-border flex items-center justify-between p-3 py-2 pb-[calc(env(safe-area-inset-bottom)_+_1rem)]"
  >
    <TabbarItem to="/" icon="ic:outline-home" title="Start" />
    <TabbarItem
      to="/scan"
      icon="ic:round-qr-code-scanner"
      :disabled="!currentConstructionSite && !hasGeolocation"
      title="Scannen"
    />
    <TabbarItem to="/history" icon="ic:baseline-history" title="Historie" />
    <TabbarItem to="/settings" icon="ic:outline-settings" title="Einstellungen" />
  </div>
</template>
